import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface RecordingProfile {
  id: string;
  imgUrl: string;
  username: string;
  fullName?: string;
  country: string;
}

export interface Recording {
  id: string;
  title: string;
  videoUrl: string;
  thumbNailUrl: string;
  sharedVideoUrl: string;
  m3u8Url: string;
  duration: string;
  punchCount: number;
  status: string;
  isFavorite: boolean;
  profile?: RecordingProfile;
  createdAt: string;
  isHighest: boolean;
}

export interface RecordingListResponse {
  isSuccess: boolean;
  pageNo: number;
  items: Recording[];
  pageSize: number;
  count: number;
  total: number;
  totalRecords: number;
}

@Injectable({ providedIn: 'root' })
export class UserRecordingService {

  private baseUrl = `${environment.apiurls.baseUrl}videoSessions/get/MarketingGrantedVideos`;

  constructor(private http: HttpClient) {}

  getRecordings(pageNo: number, pageSize: number, search?: string): Observable<RecordingListResponse> {
    const params: any = {
      pageNo: pageNo.toString(),
      pageSize: pageSize.toString()
    };
    if (search && search.trim()) {
      params.search = search.trim();
    }
    return this.http.get<RecordingListResponse>(this.baseUrl, { params });
  }
}